/**
 * Xero OAuth2 broker configuration.
 * Used by the shared auth service that redirects users to Xero and back.
 */
const xeroConfig = {
  /** Base URL of the Xero OAuth2 auth service (no trailing slash) */
  authServiceBaseUrl:
    typeof window !== 'undefined' && window.xeroAuthServiceBaseUrl
      ? window.xeroAuthServiceBaseUrl
      : 'https://xerooauth2-e6g6fsbhh4fdb9bg.australiaeast-01.azurewebsites.net',

  /** Default path on your site where users are redirected after Xero auth (success or failure) */
  defaultCallbackPath: '/xero-callback',
}

export const XERO_CONNECT_PATH = '/Authorization/Connect'

export default xeroConfig
